
import React from 'react';
import { useParams } from 'react-router-dom';
import { StudentDetailsContent } from '../components/student-details/StudentDetailsContent';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { Helmet } from 'react-helmet-async';

const StudentDetails = () => {
  const { id } = useParams<{ id: string }>();
  
  if (!id) {
    return (
      <div className="w-full">
        <Helmet>
          <title>Student Not Found - NALC Student Program & Fee Tracker</title>
        </Helmet>
        Student ID is required
      </div>
    );
  }
  
  return (
    <div className="w-full">
      <Helmet>
        <title>Student Details - NALC Student Program & Fee Tracker</title>
      </Helmet>
      <ErrorBoundary>
        <StudentDetailsContent studentId={id} />
      </ErrorBoundary>
    </div>
  );
};

export default StudentDetails;
